import QRCode from "qrcode";
import React, { useRef } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons

// core components
import GridContainer from "components/Grid/GridContainer.js";
// import GridItem from "components/Grid/GridItem.js";
// import CardBody from "components/Card/CardBody.js";
// import CardHeader from "components/Card/CardHeader.js";

// import Parallax from "components/Parallax/Parallax.js";

import styles from "assets/jss/material-kit-react/views/loginPage.js";
import { useTranslation } from 'react-i18next';
import { Grid } from "@material-ui/core";
const useStyles = makeStyles(styles);



export default function SucessPageInside(props) {

    const classes = useStyles();
    const { t, i18n } = useTranslation();
    const [digitalIdentityKey, setDigitalIdentityKey] = React.useState("");
    const canvasRef = useRef();

    async function fetchDigitalIdentityData() {
        const res = await fetch("/personalinfo/getidentity");
        res.text().then(res => {
            setDigitalIdentityKey(res);
            QRCode.toCanvas(
                canvasRef.current,
                // QR code doesn't work with an empty string
                // so we are using a blank space as a fallback
                res || " ", { width: 208, height: 208 },
                (error) => error && console.error(error)
            );
        });
    }
    React.useEffect(() => {
        fetchDigitalIdentityData();
    }, []);

    return (
        <div>
            <GridContainer justify="center" alignItems="center" className="successSection1">
                <GridContainer justify="center" alignItems="center" className="successSection1Inner">
                    <GridContainer justify="center" alignItems="center">
                        <div className="semibold-h500 textCenter cl-secondary-100">{t("SuccessPageSection1TitlePart1")}<span className="bg-primary-500">{t("SuccessPageSection1TitlePart2")}</span>{t("SuccessPageSection1TitlePart3")}</div>
                    </GridContainer>
                    <div className="successSection1Footer semibold-b100 cl-secondary-100">{t("SuccessPageSection1Scroll")}</div>
                </GridContainer>
            </GridContainer>
            <div className="successSection2">
                <div className="text">
                    <Grid item xs={12} sm={12} md={6}>
                        <div className="semibold-h400">
                            {t("SuccessPageSection2Title")}
                        </div>
                        <div className="regular-h200 paddingTop48">
                            {t("SuccessPageSection2Description1")}
                            <br></br><br></br>
                            {t("SuccessPageSection2Description2")}
                        </div>
                    </Grid>
                </div>
                {/*<div style={{ textAlign: "center" }}>
                    <canvas ref={canvasRef} />
                </div>
                <div className={classes.spacing}></div>
                 <div className="paddingBottom16" style={{ textAlign: "center" }}>
                    <a target="_system" href="/personalinfo/getpassbook">
                        <img width="165" src="/img/addtowallet.svg" />
                    </a>
                    <a style={{ paddingLeft: "24px" }} target="_system" href="/personalinfo/getidentityimage">
                        <img src="/img/downloadqr.svg" />
                    </a>
                </div> */}
                <div className="spaceBetweenWrapper paddingTop64">
                    <div className="successSection2Card successSection2Card1" onClick={() => { window.open(t("SuccessPageSection2CardPath1"), '_blank') }}>
                        <div className="semibold-h500 cl-secondary-100">1</div>
                        <div className="cardDescription">
                            <div className="semibold-h300 cl-secondary-100 paddingBottom24">{t("SuccessPageSection2CardHeader1")}</div>
                            <div className="regular-b300 cl-secondary-100">{t("SuccessPageSection2CardBody1")}</div>
                        </div>
                    </div>
                    <div className="successSection2Card successSection2Card2" onClick={() => { window.open(t("SuccessPageSection2CardPath2"), '_blank') }}>
                        <div className="semibold-h500 cl-secondary-100">2</div>
                        <div className="cardDescription">
                            <div className="semibold-h300 cl-secondary-100 paddingBottom24">{t("SuccessPageSection2CardHeader2")}</div>
                            <div className="regular-b300 cl-secondary-100">{t("SuccessPageSection2CardBody2")}</div>
                        </div>
                    </div>
                    <div className="successSection2Card successSection2Card3" onClick={() => { window.open(t("SuccessPageSection2CardPath3"), '_blank') }}>
                        <div className="semibold-h500 cl-secondary-100">3</div>
                        <div className="cardDescription">
                            <div className="semibold-h300 cl-secondary-100 paddingBottom24">{t("SuccessPageSection2CardHeader3")}</div>
                            <div className="regular-b300 cl-secondary-100">{t("SuccessPageSection2CardBody3")}</div>
                        </div>
                    </div>
                    <div className="successSection2Card successSection2Card4" onClick={() => { window.open(t("SuccessPageSection2CardPath4"), '_blank') }}>
                        <div className="semibold-h500 cl-secondary-100">4</div>
                        <div className="cardDescription">
                            <div className="semibold-h300 cl-secondary-100 paddingBottom24">{t("SuccessPageSection2CardHeader4")}</div>
                            <div className="regular-b300 cl-secondary-100">{t("SuccessPageSection2CardBody4")}</div>
                        </div>
                    </div>
                </div>
                <div className="text" style={{paddingTop: "128px"}}>
                    <Grid item xs={12} sm={12} md={6} className="regular-b300">
                        <div className="semibold-h400 paddingBottom24">{t("DigitalIdentityDetail_SuccessPageHeader")}</div>
                        <div className="regular-b300 paddingBottom24">
                        {t("DigitalIdentityDetail_SuccessPage_Section2_Description1_1")}
                        <a
                        className='cl-primary-500 semibold-b300' style={{cursor: "pointer"}}
                        onClick={() => { window.open('/DigitalId', '_self') }}>{t("DigitalIdentityDetail_SuccessPage_Section2_Description1_2")}</a>
                        {t("DigitalIdentityDetail_SuccessPage_Section2_Description1_3")}
                        </div>
                        <div className="semibold-b300 paddingBottom24">{t("DigitalIdentityDetail_Section2_Description2")}</div>
                        <div className="regular-b300 paddingBottom24">{t("DigitalIdentityDetail_Section2_Description3")}</div>
                        <div className="regular-b300">{t("DigitalIdentityDetail_Section2_Description4")}</div>
                    </Grid>
                </div>
                <div className="paddingTop64 paddingBottom90 centerWrapper">
                    <a
                        className='cl-secondary-100 semibold-b300 myIeseButton'
                        onClick={() => { window.open('https://alumni.iese.edu/', '_blank') }}>{t("Discover")}</a>
                </div>
            </div>
            {/* <Parallax image={require("assets/img/principal.jpg")} />
        <GridContainer justify="center">
            <GridItem xs={12} sm={12} md={8}>
                <form className={classes.form} style={{borderRadius: "8px"}}>
                    <CardHeader>
                        <div style={{width: "20px"}}></div>
                    </CardHeader>
                    <CardBody>
                        <GridContainer  justify = "center">
                            <GridItem xs={11} sm={11} md={11}>
                                <div>
                                    <img src={require('assets/img/check.png')} alt= {"check"} style={{maxWidth: "160px", width: "100%", display: "block",  marginLeft: "auto",  marginRight: "auto"}} />
                                    <h2 className={classes.defaultFont} style={{textAlign: "center"}}>{t("PaymentSucess")}</h2>
                                </div>
                            </GridItem>
                        </GridContainer>
                    </CardBody>
                </form>
            </GridItem>
        </GridContainer> */}
        </div>
    );
}